import { Button, SizableText, YStack } from '@my/ui'

export interface GroupPostReportedProps {
  onClose: () => void
  onUndoReport: () => void
}

export const GroupPostReported = (props: GroupPostReportedProps) => {
  return (
    <YStack gap="$4">
      <SizableText ta="center" size="$7" fow="600" color="$black">
        Thanks for reporting!
      </SizableText>
      <YStack gap="$3">
        <Button theme="black" onPress={props.onClose}>
          Close
        </Button>
        <Button plain onPress={props.onUndoReport}>
          Undo report
        </Button>
      </YStack>
    </YStack>
  )
}
